import Api from '@/apis/base.api';
import Vue from 'vue';

export const AIAnalyzeStatus = {
  BEF: 'BEF', //초기값
  ING: 'ING', //진행중
  FLR: 'FLR', //에러
  FIN: 'FIN', //완료
  UNK: 'UNK' //알려지지않은 상태
};

const AIAnalyze = {
  type: null,
  solarExamineReport: null,
  targetImageCount: null,
  processStatus: 'BEF',
  processRate: 0.0,
  jobRefSeq: null
};
const state = {
  aIAnalyzes: AIAnalyze
};

const getters = {
  getProgressPercent: (state) => (reportId) => {
    console.log('getProgressPercent', reportId);
    const analyze = state.aIAnalyzes[reportId];
    console.log('getProgressPercent', analyze);
    return analyze ? analyze.progressPercent : 0; // 기본값 0
  },
  getAIAnalyzeStatus: (state) => (reportId) => {
    const analyze = state.aIAnalyzes[reportId];
    return analyze ? analyze.aIAnalyzeStatus : AIAnalyzeStatus.initial; // 기본값 초기 상태
  },
  getReportName: (state) => (reportId) => {
    return state.aIAnalyzes[reportId]?.reportName || '';
  }
};

const mutations = {
  setAIAnalyzeStatus(state, { reportId, status }) {
    Vue.set(state.aIAnalyzes, reportId, status);
  }
};
/**
 * @description AI 분석상태 조회 및 분석요청
 */
const actions = {
  /** ai 분석 상태 fetch */
  // fetchAIAnalyzeStatus({ commit }, { reportId }) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       const response = Api.get(`/api/ai/start/754`);
  //       if (response.data?.result === "S") {
  //         commit("setAIAnalyzeStatus", {
  //           reportId,
  //           status: response.data?.data.status,
  //         });
  //         resolve(response.data?.data);
  //       } else {
  //         reject(new Error(response.data?.resultDesc));
  //       }
  //     } catch (error) {
  //       console.error("테스트 fetchAIAnalyzeStatus failed:", error);
  //       reject(error);
  //     }
  //   });
  // },
  /**
	 * @description AI 분석 요청
	 */
  requestAIAnalyze({ commit }, { reportId }) {
    return new Promise((resolve, reject) => {
      try {
        const response = Api.post(`/api/ai/start/${reportId}`);
        if (response.data?.result === 'S') {
          resolve(response.data?.data);
        } else {
          reject(new Error(response.data?.resultDesc));
        }
      } catch (error) {
        console.error('테스트 requestAIAnalyze failed:', error);
        reject(error);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
